import React, { Suspense } from "react";
import { Navigate, Outlet } from "react-router-dom";
import ProjectLayout from "../ProjectLayout/Index";
import { Skeleton } from "antd";
import { getLocalStorageItem } from "../Utils/Index";

function ProtectedAuth() {
  const isAuthenticated = () => {
    const user = getLocalStorageItem("access_token");
    return user;
  };

  return isAuthenticated() ? (
    <>
      {" "}
      <ProjectLayout>
          <Suspense
            fallback={
              <>
                <Skeleton active className="mt-4" />
                <Skeleton active className="mt-4" />
                <Skeleton active className="mt-4" />
                <Skeleton active className="mt-4" />
              </>
            }
          >
            <Outlet />
          </Suspense>
      </ProjectLayout>
    </>
  ) : (
    <>
      <Navigate to="/" replace />
    </>
  );
}
export default ProtectedAuth;
